import "jquery-match-height";

jQuery(function ($) {
  $(".layout-card").matchHeight({
    byRow: false,
    property: 'height',
    // target: null,
    // remove: false
  });
});
